<div class="statements">
	<div class="statements__title-block">
		<div class="statements__title-block-icon">
			<app-svg-documents width="100%" height="100%"></app-svg-documents>
		</div>
		<h3 class="statements__title-block-text">
			{{ title }}
		</h3>
	</div>

	@if(referencesOrdered$ | async; as referencesOrdered){ @if(referencesOrdered.length) {
	<section class="statements__block statements__block--reference-ordered">
		<div class="references-block__list-wrapper">
			<app-list
				[items]="referencesOrdered"
				[emptyLabel]="'Заказанные справки отсутствуют'"
				[defaultLimitTo]="5"
				[expandLabel]="'Показать все'"
				[collapseLabel]="'Свернуть'"
			>
				<ng-template let-item>
					<div class="statements__item">
						<app-reference-ordered [reference]="item"></app-reference-ordered>
					</div>
				</ng-template>
			</app-list>
		</div>
	</section>
	} }

	<section class="statements__block">
		<h3 class="statements__sub-title-block-text">Новая справка</h3>

		@if (references$ | async; as references) {
		<div class="references-block__list-wrapper">
			<app-list
				[items]="references.references"
				[emptyLabel]="references.emptyListText"
				[defaultLimitTo]="5"
				[expandLabel]="'Показать все'"
				[collapseLabel]="'Свернуть'"
			>
				<ng-template let-item>
					@if (item.groupId) {
					<app-references-group-wizard [group]="item"></app-references-group-wizard>
					} @else {
					<app-references-without-group-wizard
						[reference]="item"
					></app-references-without-group-wizard>
					}
				</ng-template>
			</app-list>
		</div>
		} @else {
		<div class="statements__block-loader">
			<app-round-loader></app-round-loader>
		</div>
		}
	</section>
</div>
